export const KEY = {
  SELECTED_CLIENT_ID: 'fm_selectedClientId',
  SELECTED_SITE_ID: 'fm_selectedSiteId',
  SELECTED_SECTOR_ID: 'fm_selectedSectorId',
  SELECTED_EVENT_MANAGER_ID: 'fm_selectedEventManagerId',
  DELETED_EVENT_MANAGER_ID: 'fm_deletedEventManagerId',
  SELECTED_EVENT_MANAGER_ROW_USER_ID: 'fm_selectedEventManagerRowUserId',
  SELECTED_EVENT_MANAGER_COL_DATE: 'fm_selectedEventManagerColDate',
  SELECTED_THEME_ID: 'fm_selectedThemeId',
  CALENDAR_ITEM_ZOOM: 'fm_calendarItemZoom',
  SELECTED_EVENT_ID: 'fm_selectedEventId',
  SELECTED_ENGAGEMENT_ID: 'fm_selectedEngagementId',
};